import { render, staticRenderFns } from "./componentConfig.vue?vue&type=template&id=391c41d3&"
import script from "./componentConfig.vue?vue&type=script&lang=js&"
export * from "./componentConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports